import { createSelector } from '@ngrx/store';
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
const getStartDate = createSelector(getChartState, (chartState) => chartState.startDate);
const getChartData = createSelector(getChartState, (chartState) => chartState.chartData);
const getChartDataStartDate = createSelector(getChartData, (chartData) => chartData.start_date);
export const getChartStartDate = createSelector(getStartDate, getChartDataStartDate, (startDate, chartDataStartDate) => {
    const dateToUse = startDate || chartDataStartDate;
    return dateToUse ? new Date(dateToUse) : null;
});
